<template>
  <router-view />
  <!-- 全局重新登录框：token 失效时弹出，登录成功后自动重放被中断的请求 -->
  <ReloginDialog />
</template>

<script setup lang="ts">
// 根组件
import ReloginDialog from '@/components/ReloginDialog.vue'
</script>

<style>
#app {
  height: 100vh;
}
</style>
